export default function Crest({ className = "h-10 w-10" }) {
  return (
    <svg viewBox="0 0 48 56" className={className} fill="none" aria-hidden="true">
      <path
        d="M24 2 L44 10 V29 C44 42 35.5 50.5 24 54 C12.5 50.5 4 42 4 29 V10 Z"
        stroke="currentColor"
        strokeWidth="2.2"
        fill="rgba(197,160,89,0.10)"
      />
      <path d="M24 13 V45 M13.5 23 H34.5" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
    </svg>
  );
}
